<!-- PROGRESS BAR -->
<app-loader></app-loader>
<app-loader-custom></app-loader-custom>
<app-loader-components></app-loader-components>
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->
<alert></alert>
<!-- VERTICAL LAYOUT 1 -->
<ng-container *ngIf="fuseConfig.layout.style === 'vertical-layout-1'">
    <vertical-layout-1></vertical-layout-1>
</ng-container>
<!-- / THEME OPTIONS PANEL -->